// src/App.jsx
import React, { useEffect } from 'react'; 
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom'; 

// 📱 Wrappers y Componentes Base
import MobileWrapper from './components/MobileWrapper';
import ProtectedRoute from './components/ProtectedRoute';
// Landing único y responsive (PWA): un solo componente para móvil y escritorio.
import Home from './pages/HomeDesktop';
import Login from './pages/Login'; 
import LoginMobile from './pages/LoginMobile'; 
import Bienvenida from './pages/Bienvenida';
import BienvenidaMobile from './pages/BienvenidaMobile'; 
import Contacto from './pages/Contacto';
import ContactoMobile from './pages/ContactoMobile';

// 🟢 NUEVAS VISTAS CLIENTE (B2B)
import MisSucursales from './pages/client/MisSucursales';
import NuevoPedido from './pages/client/NuevoPedido';
import EstadoCuenta from './pages/client/EstadoCuenta';
import HistorialPedidos from './pages/client/HistorialPedidos';
import MiPerfil from './pages/client/MiPerfil';
import MisEmpleados from './pages/client/MisEmpleados';

// 📊 Vistas Comunes / Otras
import DetallePedido from './pages/DetallePedido';
import Predicciones from './pages/Predicciones';
import AnalisisNegocio from './pages/client/AnalisisNegocio';

// 🛡️ Vistas de Admin
import AdminAnalisis from './pages/admin/AdminAnalisis';
import AdminAlmacen from './pages/admin/AdminAlmacen';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminPedidos from './pages/admin/AdminPedidos';
import AdminClientes from './pages/admin/AdminClientes';
import AdminPagos from './pages/admin/AdminPagos';
import AdminPredicciones from './pages/admin/AdminPredicciones';
import AdminDesviaciones from './pages/admin/AdminDesviaciones';
import AdminInventario from './pages/admin/AdminInventario';
import AdminPlaneador from './pages/admin/AdminPlaneador';
import AdminBroadcast from './pages/admin/AdminBroadcast';
import AdminSolicitarPedido from './pages/admin/AdminSolicitarPedido';
import AdminDetalleSolicitud from './pages/admin/AdminDetalleSolicitud';
import EmpleadoDashboard from './pages/client/EmpleadoDashboard';

// Componente para redireccionar si ya hay sesión
function AuthRedirect({ children }) {
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    
    useEffect(() => {
        if (token && (window.location.pathname === '/' || window.location.pathname === '/login')) {
            navigate('/Bienvenida', { replace: true });
        }
    }, [token, navigate]);

    return children;
}

function App() {
    return (
        <Router>
            <AuthRedirect>
                <Routes>
                    {/* --- RUTAS PÚBLICAS --- */}
                    {/* Landing único responsive (mismo menú en móvil y web) */}
                    <Route path="/" element={<Home />} />
                    <Route 
                        path="/login" 
                        element={<MobileWrapper DesktopComponent={Login} MobileComponent={LoginMobile} onLoginSuccess={() => {}} />} 
                    />
                    <Route 
                        path='/contacto' 
                        element={<MobileWrapper DesktopComponent={Contacto} MobileComponent={ContactoMobile} />} 
                    />
                    
                    {/* --- DASHBOARD PRINCIPAL (Clientes/Empleados autenticados) --- */}
                    <Route
                        path='/bienvenida'
                        element={<ProtectedRoute><MobileWrapper DesktopComponent={Bienvenida} MobileComponent={BienvenidaMobile} /></ProtectedRoute>}
                    />

                    {/* --- 🚀 PORTAL CLIENTE (B2B) — requiere sesión --- */}

                    {/* 1. Gestión de Sucursales e Inventario */}
                    <Route path='/mis-sucursales' element={<ProtectedRoute><MisSucursales /></ProtectedRoute>} />

                    {/* 2. Nuevo Cotizador Inteligente */}
                    <Route path='/solicitud-pedido' element={<ProtectedRoute><NuevoPedido /></ProtectedRoute>}/>

                    {/* 3. Tracking de Pedidos */}
                    <Route path='/pedidos-anteriores' element={<ProtectedRoute><HistorialPedidos /></ProtectedRoute>}/>
                    <Route path='/pedidos/:id' element={<ProtectedRoute><DetallePedido /></ProtectedRoute>}/>

                    {/* 4. Finanzas y Estado de Cuenta */}
                    <Route path='/pagos' element={<ProtectedRoute><EstadoCuenta /></ProtectedRoute>}/>

                    {/* 5. Herramientas Avanzadas */}
                    <Route path='/predicciones' element={<ProtectedRoute><Predicciones /></ProtectedRoute>}/>
                    <Route path='/analisis-negocio' element={<ProtectedRoute><AnalisisNegocio /></ProtectedRoute>}/>

                    {/* 6. Perfil y Precios */}
                    <Route path='/mi-perfil' element={<ProtectedRoute><MiPerfil /></ProtectedRoute>} />
                    {/* --- GESTIÓN DE CUENTAS --- */}
                    <Route path='/mi-equipo' element={<ProtectedRoute><MisEmpleados /></ProtectedRoute>} />

                    {/* --- 🛡️ PANEL DE ADMINISTRADOR — requiere rol Admin --- */}
                    <Route path='/admin' element={<ProtectedRoute allowedRoles={['Admin']}><AdminDashboard /></ProtectedRoute>} />
                    <Route path='/admin/pedidos' element={<ProtectedRoute allowedRoles={['Admin']}><AdminPedidos /></ProtectedRoute>} />
                    <Route path='/admin/solicitudes/:id' element={<ProtectedRoute allowedRoles={['Admin']}><AdminDetalleSolicitud /></ProtectedRoute>} />
                    <Route path='/admin/solicitar-pedido' element={<ProtectedRoute allowedRoles={['Admin']}><AdminSolicitarPedido /></ProtectedRoute>} />

                    <Route path='/admin/clientes' element={<ProtectedRoute allowedRoles={['Admin']}><AdminClientes /></ProtectedRoute>} />
                    <Route path='/admin/pagos' element={<ProtectedRoute allowedRoles={['Admin']}><AdminPagos /></ProtectedRoute>} />

                    <Route path='/admin/predicciones' element={<ProtectedRoute allowedRoles={['Admin']}><AdminPredicciones /></ProtectedRoute>} />
                    <Route path='/admin/desviaciones' element={<ProtectedRoute allowedRoles={['Admin']}><AdminDesviaciones /></ProtectedRoute>} />
                    <Route path='/admin/planeador' element={<ProtectedRoute allowedRoles={['Admin']}><AdminPlaneador /></ProtectedRoute>} />
                    <Route path='/admin/inventario' element={<ProtectedRoute allowedRoles={['Admin']}><AdminInventario /></ProtectedRoute>} />

                    <Route path='/admin/broadcast' element={<ProtectedRoute allowedRoles={['Admin']}><AdminBroadcast /></ProtectedRoute>} />
                    <Route path="/admin/almacen" element={<ProtectedRoute allowedRoles={['Admin']}><AdminAlmacen /></ProtectedRoute>} />
                    <Route path="/admin/analisis" element={<ProtectedRoute allowedRoles={['Admin']}><AdminAnalisis /></ProtectedRoute>} />
                    <Route path="/dashboard-empleado" element={<ProtectedRoute allowedRoles={['Empleado','Admin']}><EmpleadoDashboard /></ProtectedRoute>} />
                </Routes>
            </AuthRedirect>
        </Router>
    );
}

export default App;